import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { SelectImageData, variant_type } from "../../../utils/common";
import VarientSection from "./Varient";
library.add(fas);

// Stock is kept only on the last level of a product's variant type, so these
// are the places a purchased quantity can go.
const getStockLeafCount = (variants, variantTypeId) => {
  const doubles = variants.flatMap((variant) => variant?.Double_Variants || []);
  switch (Number(variantTypeId)) {
    case variant_type.Single:
      return variants.length;
    case variant_type.Double:
      return doubles.length;
    case variant_type.Triple:
      return doubles.flatMap((dvariant) => dvariant?.Triple_Variants || [])
        .length;
    default:
      return 0;
  }
};

const getLeafStockTotal = (varients, variantTypeId) => {
  const toNumber = (value) => parseFloat(value) || 0;
  const doubles = (varients || []).flatMap(
    (variant) => variant?.double_variants || []
  );
  switch (Number(variantTypeId)) {
    case variant_type.Single:
      return (varients || []).reduce(
        (sum, variant) => sum + toNumber(variant?.general_stock),
        0
      );
    case variant_type.Double:
      return doubles.reduce((sum, dvariant) => sum + toNumber(dvariant?.stock), 0);
    case variant_type.Triple:
      return doubles
        .flatMap((dvariant) => dvariant?.triple_variants || [])
        .reduce((sum, tvariant) => sum + toNumber(tvariant?.stock), 0);
    default:
      return 0;
  }
};

// Same shape EditReceiving.js sends. The ids come from the fetched variants
// rather than the hidden inputs, so changing a row's product can't leave stale ids.
const buildVarients = (variants, productOption, varientValues) => {
  const typeId = Number(productOption?.variant_type_id);
  const stockFor = (type, value) =>
    typeId === type ? parseFloat(value) || 0 : 0;

  return variants.map((variant, SIndex) => {
    const variantValues = varientValues?.[SIndex];
    return {
      product_id: productOption?.value,
      variant_id: variant?.id,
      general_stock: stockFor(variant_type.Single, variantValues?.general_stock),
      double_variants: (variant?.Double_Variants || []).map(
        (dvariant, DIndex) => {
          const doubleValues = variantValues?.double_variants?.[DIndex];
          return {
            d_variant_id: dvariant?.id,
            stock: stockFor(variant_type.Double, doubleValues?.stock),
            triple_variants: (dvariant?.Triple_Variants || []).map(
              (tvariant, TIndex) => ({
                t_variant_id: tvariant?.id,
                stock: stockFor(
                  variant_type.Triple,
                  doubleValues?.triple_variants?.[TIndex]?.stock
                ),
              })
            ),
          };
        }
      ),
    };
  });
};

const getRowTotal = (row) =>
  (parseFloat(row?.quantity) || 0) * (parseFloat(row?.price) || 0);

const allowDecimalKeys = (e) => {
  if (
    e.key === "Backspace" ||
    e.key === "ArrowLeft" ||
    e.key === "ArrowRight"
  ) {
    return; // Allow the action to continue
  }

  // Allow digits and decimal point
  if (!/[\d.]/.test(e.key)) {
    e.preventDefault(); // Block the invalid key
  }

  if (e.key === "." && e.target.value.includes(".")) {
    e.preventDefault();
  }
};

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);

  const [product, setProduct] = useState([]);
  // Variants of the product picked on each row, keyed by the row's field id
  const [rowVariants, setRowVariants] = useState({});
  const latestVariantRequest = useRef({});

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");

    if (response?.success) {
      setProduct(
        response?.data?.map((data) => ({
          value: data?.id,
          label: data?.name,
          variant_type_id: data?.variant_type_id,
          name: "product_id",
        }))
      );
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    watch,
    getValues,
  } = useForm();

  const watchQuantitys = watch("quantitys"); // watches the entire array

  const [CancellationPolicyError, setCancellationPolicyError] = useState("");
  useEffect(() => {
    register("quantitys", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setCancellationPolicyError(
          isValid ? "" : "At least one Purchase Quanitity is required"
        );
        return isValid;
      },
    });
  }, [register]);

  // A row split across variants takes its quantity from the stock entered per variant
  useEffect(() => {
    const subscription = watch((values, { name }) => {
      const match = name?.match(/^quantitys\.(\d+)\.varients\./);
      if (!match) return;
      const row = values?.quantitys?.[match[1]];
      setValue(
        `quantitys.${match[1]}.quantity`,
        String(
          getLeafStockTotal(row?.varients, row?.product_id?.variant_type_id)
        ),
        { shouldValidate: true }
      );
    });
    return () => subscription.unsubscribe();
  }, [watch, setValue]);

  const totalQuantity =
    watchQuantitys?.reduce((sum, item) => {
      const qty = parseFloat(item?.quantity);
      return sum + (isNaN(qty) ? 0 : qty);
    }, 0) || 0;

  const totalPrice =
    watchQuantitys?.reduce((sum, item) => sum + getRowTotal(item), 0) || 0;

  // Variants to split the row's quantity across, or null when the whole
  // quantity goes to the product's only stock holding variant
  const getSplitVariants = (fieldId, productOption) => {
    const variants = rowVariants[fieldId];
    if (
      !variants ||
      getStockLeafCount(variants, productOption?.variant_type_id) <= 1
    ) {
      return null;
    }
    return variants;
  };

  const handleProductChange = async (index, fieldId, selectedOption) => {
    latestVariantRequest.current[fieldId] = selectedOption?.value;
    setRowVariants((prev) => ({ ...prev, [fieldId]: undefined }));
    setValue(`quantitys.${index}.varients`, []);
    setValue(`quantitys.${index}.quantity`, "");

    const response = await getData(
      `/common/masters/product-varient/${selectedOption?.value}`
    );
    // The row's product was changed again while this was loading
    if (latestVariantRequest.current[fieldId] !== selectedOption?.value) return;

    setRowVariants((prev) => ({
      ...prev,
      [fieldId]: response?.success ? response?.data : [],
    }));
  };

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("total_quantity", totalQuantity);
      DataToSend.append("supplier_id", data?.supplier_id?.value);
      const variants = [];
      data.quantitys.forEach((val, index) => {
        const item = {
          product_id: val?.product_id?.value,
          quantity: val.quantity,
          price: parseFloat(val?.price) || 0,
        };
        const splitVariants = getSplitVariants(
          fields[index]?.id,
          val?.product_id
        );
        if (splitVariants) {
          item.varients = buildVarients(
            splitVariants,
            val?.product_id,
            val?.varients
          );
        }
        variants.push(item);
      });

      DataToSend.append("quantitys", JSON.stringify(variants));

      const response = await postData(
        `/admin/purchase-order/purchase-product`,
        DataToSend
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        // Keep the form open on an error so it can be corrected
        if (response?.success) {
          props.handleClose();
        }
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "quantitys",
  });

  const [supplier, setSupplier] = useState([]);
  const GetAllSupplier = async () => {
    const response = await getData("/common/masters/all-supplier");
    if (response?.success) {
      setSupplier(await Select2Data(response?.data, "supplier_id"));
    }
  };
  useEffect(() => {
    GetAllSupplier();
  }, []);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Purchase
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            // className="stateclass"
          >
            <Row>
              
              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Supplier</Form.Label>

                    <Controller
                      name="supplier_id" // name of the field
                      {...register("supplier_id", {
                        required: "Select City",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.supplier_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={supplier}
                          // onChange={(selectedOption) => {
                          //   field.onChange(selectedOption.value); // Update Controller's value
                          //   GetAllStates(selectedOption.value);
                          //   setValue("country_id", selectedOption);
                          //   setValue("state_id", null);
                          // }}
                        />
                      )}
                    />

                    {errors.supplier_id && (
                      <span className="text-danger">
                        {errors.supplier_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col> */}

              <div className="oder-detail-holder mb-3">
                <div className="heading-holder">
                  <h6> Purchase Quanitity</h6>
                </div>

                <div className="package-details-section">
                  {fields.map((variant, index) => {
                    const row = watchQuantitys?.[index];
                    const splitVariants = getSplitVariants(
                      variant.id,
                      row?.product_id
                    );
                    return (
                      <div key={variant.id} className="main-form-section mt-3">
                        <Row>
                          <Col md={4}>
                            <div className="main-form-section mt-3">
                              <Row className="justify-content-center">
                                <Form.Label>Product</Form.Label>
                                <Form.Group>
                                  <Controller
                                    name={`quantitys.${index}.product_id`} // name of the field
                                    {...register(
                                      `quantitys.${index}.product_id`,
                                      {
                                        required: "Select Product",
                                      }
                                    )}
                                    control={control}
                                    render={({ field }) => (
                                      <Select
                                        styles={{
                                          control: (baseStyles) => ({
                                            ...baseStyles,
                                            borderColor: errors?.add_on?.[index]
                                              ?.product_id
                                              ? "red"
                                              : baseStyles,
                                          }),
                                        }}
                                        {...field}
                                        options={product}
                                        onChange={(selectedOption) => {
                                          field.onChange(selectedOption);
                                          handleProductChange(
                                            index,
                                            variant.id,
                                            selectedOption
                                          );
                                        }}
                                      />
                                    )}
                                  />
                                  {errors?.quantitys?.[index]?.product_id && (
                                    <span className="text-danger">
                                      {errors.quantitys[index].product_id.message}
                                    </span>
                                  )}
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="main-form-section mt-3">
                              <Row className="justify-content-center">
                                <Form.Label>Quanitity</Form.Label>
                                <Form.Group>
                                  <Form.Control
                                    type="text"
                                    name={`quantitys.${index}.quantity`} // Register color for the variant
                                    placeholder={
                                      splitVariants
                                        ? "Sum of variant stock"
                                        : "Quanitity"
                                    }
                                    readOnly={!!splitVariants}
                                    className={classNames("", {
                                      "is-invalid":
                                        errors?.quantitys?.[index]?.quantity,
                                    })}
                                    {...register(`quantitys.${index}.quantity`, {
                                      required: "Quanitity is required",
                                      validate: (value) =>
                                        value.length <= 200 ||
                                        "Data must be 200 characters or less",
                                    })}
                                    onKeyDown={allowDecimalKeys}
                                  />
                                  {errors?.quantitys?.[index]?.quantity && (
                                    <span className="text-danger">
                                      {errors.quantitys[index].quantity.message}
                                    </span>
                                  )}
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="main-form-section mt-3">
                              <Row className="justify-content-center">
                                <Form.Label>Price</Form.Label>
                                <Form.Group>
                                  <Form.Control
                                    type="text"
                                    name={`quantitys.${index}.price`}
                                    placeholder="Price"
                                    {...register(`quantitys.${index}.price`)}
                                    onKeyDown={allowDecimalKeys}
                                  />
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="main-form-section mt-3">
                              <Row className="justify-content-center">
                                <Form.Label>Total</Form.Label>
                                <Form.Group>
                                  <Form.Control
                                    type="text"
                                    value={getRowTotal(row).toFixed(2)}
                                    readOnly
                                  />
                                </Form.Group>
                              </Row>
                            </div>
                          </Col>

                          {splitVariants && (
                            <VarientSection
                              product_id={row?.product_id}
                              Index={index}
                              control={control}
                              register={register}
                              getValues={getValues}
                              errors={errors}
                              setValue={setValue}
                              baseName="quantitys"
                            />
                          )}
                        </Row>
                        {fields.length > 1 && (
                          <button
                            className="mt-3 add-varient"
                            type="button"
                            onClick={() => remove(index)} // Remove the variant
                          >
                            Remove Product
                          </button>
                        )}
                        <hr />
                      </div>
                    );
                  })}
                  {CancellationPolicyError && (
                    <div className="text-danger">{CancellationPolicyError}</div>
                  )}
                  <div>Total Quantity:{totalQuantity}</div>
                  <div>Total Price:{totalPrice.toFixed(2)}</div>
                </div>
                <hr />
                <div className="text-center">
                  <button
                    type="button"
                    className="add-varient"
                    onClick={() => append({})}
                  >
                    + Add Product
                  </button>
                </div>
              </div>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
